import React from 'react'

const Footer = () => <footer>Yellow & Yellow Fashion</footer>

export default Footer
